import { render, staticRenderFns } from "./UpdateMembre.vue?vue&type=template&id=dd28aec2&"
import script from "./UpdateMembre.vue?vue&type=script&lang=ts&"
export * from "./UpdateMembre.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateMembre.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports